<template>
  <div class="opinion_list" v-loading="loading">
    <div class="s_wrapper">
      <el-date-picker class="" v-model="datetime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="onSearch" clearable></el-date-picker>
      <el-input class="s_input" v-model="userName" placeholder="请输入用户名称" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
      <el-select class="s_input" v-model="demandType" placeholder="反馈类型" @change="onSearch" clearable>
        <el-option label="问题" :value="1"></el-option>
        <el-option label="建议" :value="2"></el-option>
      </el-select>
      <!-- <el-select class="s_input" v-model="bizSys" placeholder="反馈来源" @change="onSearch" clearable>
        <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select> -->
      <!-- <el-select class="s_input" v-model="replyStatus" placeholder="选择处理状态" @change="onSearch" clearable>
        <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select> -->
      <!-- <el-button class="btn" type="primary" plain>导出</el-button> -->
    </div>

    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" height="540">
        <el-table-column label="序号" show-overflow-tooltip width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="userName" label="用户名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="content" label="反馈内容"></el-table-column>
        <!-- <el-table-column label="反馈来源">
          <template slot-scope="scope">
            <span v-if="scope.row.bizSys == 1">采购商</span>
            <span v-if="scope.row.bizSys == 2">供应商</span>
            <span v-if="scope.row.bizSys == 3">线上商城</span>
          </template>
        </el-table-column> -->
        <el-table-column label="反馈类型">
          <template slot-scope="scope">
            <span v-if="scope.row.demandType == 1">问题</span>
            <span v-if="scope.row.demandType == 2">建议</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="createdTime" label="反馈时间"></el-table-column>
        <!-- <el-table-column label="图片">
          <template slot-scope="scope">
            <span class="show_img" @click="previewPic(scope.row)">查看图片</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column show-overflow-tooltip prop="" label="处理状态">
          <template slot-scope="scope">
            <span :style="scope.row.replyStatus == 0 ? 'color:red;' : ''">{{ scope.row.replyStatus == 0 ? "未回复" : "已回复" }}</span>
          </template>
        </el-table-column> -->
        <el-table-column show-overflow-tooltip label="操作" header-align="center" align="center" width="120">
          <template slot-scope="scope">
            <el-button type="" plain @click="handleShow(scope.row)">查看详情</el-button>
            <!-- <el-button v-if="scope.row.replyStatus == 0" type="primary" plain @click="handleShow(scope.row)">回复意见</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <el-dialog :title="isAdd ? '回复意见' : '查看详情'" :visible.sync="dialogVisible" :close-on-click-modal="false" v-loading="dialogLoding">
      <el-form :model="ruleForm" ref="ruleForm" label-width="120px" class="ruleForm">
        <el-row type="flex" justify="center">
          <!-- <el-col :span="12">
            <el-form-item label="反馈来源">
              <el-select class="s_input" v-model="ruleForm.bizSys" placeholder="反馈来源" disabled>
                <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="12" v-if="ruleForm.bizSys != 3">
            <el-form-item label="公司名称">
              <el-input v-model="ruleForm.userName" disabled></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="用户名称">
              <el-input v-model="ruleForm.userName" disabled></el-input>
            </el-form-item>
            <!-- </el-col> -->
            <!-- <el-col :span="12"> -->
            <el-form-item label="反馈类型">
              <el-input v-if="ruleForm.demandType == 1" value="问题" disabled></el-input>
              <el-input v-if="ruleForm.demandType == 2" value="建议" disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- </el-row> -->
          <!-- <el-row> -->
          <el-col :span="12">
            <el-form-item label="反馈时间">
              <el-input v-model="ruleForm.createdTime" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col :span="24">
            <el-form-item label="反馈内容">
              <el-input v-model="ruleForm.content" type="textarea" :rows="4" resize="none" disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24">
            <el-form-item label="回复内容" :required="isAdd">
              <el-input v-model="ruleForm.replyContent" type="textarea" :rows="4" resize="none" :disabled="!isAdd" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row type="flex" justify="center">
          <el-col :span="24">
            <el-form-item label="图片">
              <span v-if="ruleForm.picUrlsList == null" style="color: #c0c4cc">用户未上传图片</span>
              <el-image v-else class="picurl" v-for="(item, index) in ruleForm.picUrlsList" :key="index" :src="item" :preview-src-list="ruleForm.picUrlsList" fit="cover"></el-image>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer">
        <el-button @click="onCancel">关 闭</el-button>
        <el-button v-if="isAdd" type="primary" @click="onSubmit('ruleForm')" :loading="submitLoding">确 定</el-button>
      </span>
    </el-dialog>

    <el-image-viewer
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false
        }
      "
      :url-list="srcList"
    ></el-image-viewer>
  </div>
</template>

<script>
function createInitRuleForm() {
  return {
    // replyContent: "",
    demandType: "",
    userName: "",
    createdTime: "",
    content: "",
    picUrlsList: [],
  }
}
export default {
  components: {
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  data() {
    return {
      loading: false,
      demandType: "",
      bizSys: "",
      tableData: [],
      options1: [
        { value: "1", label: "采购商" },
        { value: "2", label: "供应商" },
        { value: "3", label: "线上商城" },
      ],
      options2: [
        { value: "0", label: "未回复" },
        { value: "1", label: "已回复" },
      ],
      replyStatus: "",
      userName: "",
      datetime: [],
      isAdd: false,
      showViewer: false,
      dialogLoding: false,
      dialogVisible: false,
      submitLoding: false,
      srcList: [],
      ruleForm: createInitRuleForm(),

      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 意见列表
    getList() {
      let startTime, endTime
      if (this.datetime && this.datetime.length > 0) {
        startTime = this.datetime[0]
        endTime = this.datetime[1]
      } else {
        startTime = ""
        endTime = ""
      }
      this.loading = true
      this.$axios
        .get(this.$api.userFeedbackpageList, {
          params: {
            userName: this.userName, // 用户名称
            demandType: this.demandType, // 反馈类型 (1问题；2建议)
            // bizSys: this.bizSys, // 反馈来源 (1采购商；2供应商)
            // replyStatus: this.replyStatus, // 状态 (0未回复，1已回复)
            startTime,
            endTime,
            page: this.currentPage, // 页码数
            pageSize: this.pageSize, // 每页数量
          },
        })
        .then(res => {
          this.tableData = res.result.list
          this.totalItemsCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 搜索
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getList()
    },
    // 导出
    onExprot() {
      this.tableData = []
      this.currentPage = 1
      this.getList()
    },
    handleShow(e) {
      // // if (e.replyStatus == 0) {
      // //   this.isAdd = true
      // // } else {
      // //   this.isAdd = false
      // // }
      // this.isAdd = false
      // this.ruleForm = JSON.parse(JSON.stringify(e))
      // // this.ruleForm.bizSys = e.bizSys.toString()
      // this.dialogVisible = true
      this.dialogLoding = true
      this.$axios
        .get(`${this.$api.userFeedbackdetail}/${e.id}`)
        .then(res => {
          this.ruleForm = res.result
          this.dialogLoding = false
          this.dialogVisible = true
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.dialogLoding = false
        })
    },
    // 提交回复
    onSubmit() {
      if (this.ruleForm.replyContent && this.ruleForm.replyContent != "") {
        this.submitLoding = true
        this.$axios
          .post(this.$api.userFeedbackreply, {
            id: this.ruleForm.id,
            replyContent: this.ruleForm.replyContent,
          })
          .then(res => {
            this.$message.success("回复成功")
            this.submitLoding = false
            this.dialogVisible = false
            this.getList()
          })
          .catch(err => {
            this.$message.error(err.desc)
            this.submitLoding = false
          })
      } else {
        this.$message.error("提交失败，回复内容不能为空")
      }
    },
    onCancel() {
      this.resetForm()
      this.dialogVisible = false
    },
    // 图片预览
    previewPic(e) {
      this.srcList = e.picUrlsList
      this.showViewer = true
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getList()
    },
    // 重置校验
    resetForm() {
      this.ruleForm = createInitRuleForm()
      this.$refs.ruleForm.resetFields()
    },
  },
}
</script>

<style scoped lang="scss">
.opinion_list {
  .show_img {
    color: $themes;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }

  .ruleForm {
    .picurl {
      width: 100px;
      height: 100px;

      &:not(:first-child) {
        margin-left: 16px;
      }
    }

    .el-select {
      width: 100%;
    }

    ::v-deep .el-input,
    ::v-deep .el-input__inner {
      width: 100%;
    }
  }
}
</style>
